import { Injectable } from "@angular/core";
import { gql, Mutation, Apollo } from "apollo-angular";
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};

export type ConvertIdeaToKaizenMutation = {
  createIdeaComment: { message: string };
};
export type ConvertIdeaToKaizenMutationVariables = Exact<{
  id: string;
}>;

export const convertIdeaToKaizenDocument = gql`
  mutation ConvertIdeaToKaizen($id: String!) {
    convertIdeaToKaizen(id: $id) {
      message
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ConvertIdeaToKaizenGQL extends Mutation<
  ConvertIdeaToKaizenMutation,
  ConvertIdeaToKaizenMutationVariables
> {
  document = convertIdeaToKaizenDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}
